/**
 * Enum for starting position in the Crosshair tool, which determines where the tool
 * will be initially rendered
 * @readonly
 * @enum {string}
 */
export const startingPosition = {
	/** Initially render tool at the center data point */
	CENTER: 'center',
	/** Initially render tool at left-most data point */
	LEFT: 'left',
	/** Initially render tool at right-most data point */
	RIGHT: 'right'
};

export default {
	startingPosition
};
